<button class="ag-button ag-type-{{ type }} ag-size-{{ size }} ag-color-{{ color }}" [disabled]="disabled" [class.padded]="label">
  <div class="flex-row flex-center flex-align-center" style="display: flex; gap: 8px">
    <img *ngIf="imagePath" [src]="imagePath" />
    <span *ngIf="label">{{ label }}</span>
  </div>
</button>
